import OutlineButton from '@/components/OutlineButton'
import BracketMatchup from '@/components/triumph/brackets/BracketMatchup'
import SvgLib from '@/components/SvgLib.vue'
import { TimelineMax, Expo, Power2 } from 'gsap'
import { bus } from '@/consts'

export default {
  name: 'Compete',
  template: '#compete-template',
  data () {
    return {
      introComplete: false
    }
  },
  components: { BracketMatchup, SvgLib, OutlineButton },
  methods: {
    animateBracket () {
      let bracketTl = new TimelineMax({delay: 1})
      bracketTl.fromTo(this.$refs.bracket1.$el.getElementsByClassName('bracket-vs-box')[0], 0.8, {opacity: 0, rotation: '-30deg', scale: 0}, {opacity: 1, rotation: '0deg', scale: 1, ease: Expo.easeOut})
      bracketTl.fromTo([this.$refs.bracket1.$el.getElementsByClassName('bracket-team')[0], this.$refs.bracket1.$el.getElementsByClassName('bracket-team')[1]], 0.7, {scaleX: 0}, {scaleX: 1, ease: Power2.easeInOut}, '-=0.5')
      bracketTl.fromTo(this.$refs.bracket1.$el.getElementsByClassName('line')[0], 1.6, {scaleY: 0}, {scaleY: 1, ease: Expo.easeInOut}, '-=1')
      bracketTl.fromTo([this.$refs.bracket1.$el.querySelector('.team-1 .bracket-team-content img'), this.$refs.bracket1.$el.querySelector('.team-2 .bracket-team-content img')], 0.8, {opacity: 0}, {opacity: 1}, '-=0.7')

      bracketTl.fromTo(this.$refs.bracket1.$el.querySelector('.team-1 .team-tag'), 0.6, {x: '-100%'}, {x: '0%'}, '-=0.8')
      bracketTl.fromTo(this.$refs.bracket1.$el.querySelector('.team-2 .team-tag'), 0.6, {x: '100%'}, {x: '0%'}, '-=0.8')
      bracketTl.fromTo(this.$refs.bracketContainer, 0.6, {scale: 1.1}, {scale: 1, ease: Power2.easeInOut})
      // bracketTl.fromTo(this.$refs.bracket2.$el, 0.1, {opacity: 0}, {opacity: 1})
      // bracketTl.fromTo(this.$refs.bracket1.$el, 0.9, {y: '50%'}, {y: '-20%', ease: Expo.easeInOut})
      // bracketTl.fromTo(this.$refs.bracket2.$el, 0.9, {opacity: 0, y: '-50%'}, {opacity: 1, y: '20%', ease: Expo.easeInOut}, '-=0.9')
      bracketTl.to(this.$refs.bracketContainer, 0.6, {opacity: 0.1,
        onComplete: () => {
          this.introComplete = true
        }
      }, '-=0.2')
    }
  },
  mounted () {
    this.$nextTick(() => {
      bus.$emit('closeOverlay')
      this.animateBracket()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/compete.js